/**
 * 路由页面配置
 * meta 标签配置
 * @param {String} title 网站标题
 * @param {String} requireAuth 是否需要登录
 *
 **/
const data = [
  {
    path: '/exam',
    name: 'exam',
    meta: { title: '学情分析', requireAuth: true },
    component: () => import('@view/dateCenter/exam')
  },
  {
    path: '/totalReport',
    name: 'totalReport',
    meta: { title: '全科报表', requireAuth: true },
    component: () => import('@view/dateCenter/sortReport/totalReport.vue')
  },
  {
    path: '/singleReport',
    name: 'singleReport',
    meta: { title: '单科报表', requireAuth: true },
    component: () => import('@view/dateCenter/sortReport/singleReport.vue')
  },
  {
    path: '/portrait',
    name: 'portrait',
    meta: { title: '学生画像', requireAuth: false },
    component: () => import('@view/portrait/portrait.vue')
    // 详情页
  },
  // {
  //   path: '/avvisoManage',
  //   name: 'avvisoManage',
  //   meta: { title: '通知书管理', requireAuth: false },
  //   component: () => import('@view/avvisoManage/index.vue')
  //   // 通知书管理
  // },
  // {
  //   path: '/totalReportunion',
  //   name: 'totalReportunion',
  //   meta: { title: '全科报表', requireAuth: true },
  //   component: () => import('@view/dateCenter/sortReport/totalReportunion.vue')
  // },
  // {
  //   path: '/singleReportunion',
  //   name: 'singleReportunion',
  //   meta: { title: '单科报表', requireAuth: true },
  //   component: () => import('@view/dateCenter/sortReport/singleReportunion.vue')
  // },
  {
    path: '/downloadCenter',
    name: 'downloadCenter',
    meta: { title: '下载中心', requireAuth: true },
    component: () => import('@view/downloadCenter')
  }
]
export default data
